import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { TaskContextLinkedActionItem } from '../../models/ai-assistant.models';

export type ActionItemDisplayMode = 'chip' | 'table';

@Component({
  selector: 'app-action-item-display',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './action-item-display.component.html',
  styleUrl: './action-item-display.component.css',
})
export class ActionItemDisplayComponent {
  @Input() items: TaskContextLinkedActionItem[] = [];
  @Input() mode: ActionItemDisplayMode = 'chip';
  @Input() maxRecords = 5;
  @Input() total?: number;

  get displayed(): TaskContextLinkedActionItem[] {
    return this.items.slice(0, this.maxRecords);
  }

  get overflow(): number {
    return Math.max(0, (this.total ?? this.items.length) - this.maxRecords);
  }

  get totalCount(): number {
    return this.total ?? this.items.length;
  }

  itemLabel(item: TaskContextLinkedActionItem): string {
    return item.text || item.actionItemId || '—';
  }

  assetRef(item: TaskContextLinkedActionItem): string {
    return item.assetTag || item.assetId || item.assetName || '—';
  }

  categoriesLabel(item: TaskContextLinkedActionItem): string {
    return (item.assetCategories ?? []).join(', ') || '—';
  }

  assignedLabel(item: TaskContextLinkedActionItem): string {
    const a = item.assigned;
    if (!a) return '—';
    if (typeof a === 'string') return a;
    return '—';
  }

  statusClass(status?: string): string {
    const s = (status || '').toLowerCase().replace(/\s+/g, '-');
    return `tone-${s}`;
  }
}
